import {Button} from "../../../../../Utility/Button";
import {ArrowCounterClockwise} from "@phosphor-icons/react";
import React from "react";
import useGlobals from "../../../../../../Hooks/useGlobals";
import {mcpService} from "../../../../../../Services/mcpService";
import toast from "react-hot-toast";

interface OAuthResetButtonProps {
    configId: string;
    onAuthDataChange: (authData: any) => void;
    authType: string;
}

const OAuthResetButton: React.FC<OAuthResetButtonProps> = ({configId, onAuthDataChange, authType}) => {
    const {i18n} = useGlobals();

    function discoverAuthorizationServer() {
        mcpService.discoverAuthorizationServer(configId).then((response) => {
            if (response.data.success) {
                toast.success(i18n.translate({id: 'oauth.asd.success', sourceName: 'MCP'}));
                onAuthDataChange(response.data.authData);
            } else {
                toast.error(
                    response.data.message,
                );
            }
        });
    }

    if (authType !== 'oauth') {
        return null
    }
    return (
        <div className="absolute top-4 right-12">
            <Button
                variant="transparentRound"
                onClick={discoverAuthorizationServer}
                tooltipText={i18n.translate({id: 'oauth.asd.description', sourceName: 'MCP'})}
                className="cursor-pointer"
            >
                <ArrowCounterClockwise size={18}/>
            </Button>
        </div>
    );
}

export default OAuthResetButton;
